import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  serviceFetchLastFetchedpaySlip,
  serviceGenrateSalaryPayslips,
  serviceGetSalaryReports,
  serviceIsSalaryReportGenerated,
} from "../../../services/Salary.service";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import { serviceEmployeesPayslipReport } from "../../../services/Reports.service";

const initialForm = {
  month: "",
  year: "",
};

const useSalaryReportListHook = () => {
  const [form, setForm] = useState({ ...initialForm });
  const [errorData, setErrorData] = useState({});
  const [isCalling, setIsCalling] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [currentData, setCurrentData] = useState([]);
  const [data, setData] = useState([]);
  const [totalShow, setTotalShow] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPayslipGenrated, setLastPaySlipGenrated] = useState({
    dateGenerated: "",
    lastPaySlipGenerated: "",
  });
  const isMountRef = useRef(false);

  const checkFormValidation = useCallback(() => {
    const errors = { ...errorData };
    let required = ["month", "year"];
    required.forEach((val) => {
      if (
        (form?.[val] === null ||
          form?.[val] === undefined ||
          form?.[val] === "" ||
          (Array.isArray(form?.[val]) && form?.[val].length === 0)) &&
        !(val === "month" && form?.[val] === 0)
      ) {
        errors[val] = true;
      }
    });
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });
    return errors;
  }, [form, errorData]);

  useEffect(() => {
    _processData();
  }, [data, currentPage]);

  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
    (text, fieldName) => {
      let shouldRemoveError = true;
      const t = { ...form };
      if (fieldName === "year") {
        const date = new Date(text);
        const year = date.getFullYear();
        t[fieldName] = year;
        t["month"] = "";
      } else if (fieldName === "month") {
        const date = new Date(text);
        const month = date.getMonth();
        t[fieldName] = month;
      } else {
        t[fieldName] = text;
      }

      setForm(t);
      shouldRemoveError && removeError(fieldName);
    },
    [removeError, form, setForm]
  );
  console.log("changeTextData <<< ", form, errorData, isGenerated);

  const submitToServer = useCallback(() => {
    if (!isCalling) {
      setIsCalling(true);
      isGeneratedFun();
      let req = serviceGetSalaryReports;

      req({
        ...form,
        month: form?.month + 1,
      }).then((res) => {
        if (!res.error) {
          setData(res?.data);
          handlePageChange(0);
          setIsDownload(true)
        } else {
          SnackbarUtils.error(res.message);
        }
        setIsCalling(false);
      });
    }
  }, [form, isCalling, setIsCalling, setData]);

  const fetchPaySLip = useCallback(() => {
    if (!isCalling) {
      setIsCalling(true);
      let req = serviceGenrateSalaryPayslips;
      req({
        ...form,
        month: form?.month + 1,
      }).then((res) => {
        if (!res.error) {
          SnackbarUtils.success("Payslip Generated");
          fetchLastfetchedSalarySlip();
          isGeneratedFun();
        } else {
          SnackbarUtils.error(res.message);
        }
        setIsCalling(false);
      });
    }
  }, [form, isCalling, setIsCalling, setData]);

  const handleDownload = useCallback(() => {
    if (!isCalling) {
      setIsCalling(true);
      let req = serviceEmployeesPayslipReport;
      req({
        ...form,
        month: form?.month + 1,
      }).then((res) => {
        if (!res.error) {
          const data = res.data;
          window.open(data, "_blank");
        } else {
          SnackbarUtils.error(res.message);
        }
        setIsCalling(false);
      });
    }
  }, [form,isCalling]);

  const isGeneratedFun = useCallback(() => {
    const fd = {
      ...form,
      month: form?.month + 1,
    };
    let req = serviceIsSalaryReportGenerated;
    req({ ...fd }).then((res) => {
      if (!res.error) {
        setIsGenerated(res.data.is_generated);
      }
    });
  }, [isGenerated, form]);

  useEffect(() => {
    fetchLastfetchedSalarySlip();
  }, []);

  const fetchLastfetchedSalarySlip = useCallback(() => {
    let req = serviceFetchLastFetchedpaySlip;

    req().then((res) => {
      if (!res.error) {
        console.log("res ===> ", res);
        setLastPaySlipGenrated({
          ...res.data,
        });
      }
    });
  }, []);

  const _processData = useCallback(() => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  }, [setCurrentData, submitToServer, currentPage, data, totalShow]);

  const handleSortOrderChange = useCallback((row, order) => {
    // console.log(`handleSortOrderChange key:${row} order: ${order}`);
  }, []);

  const generatePaySlip = useCallback(() => {}, []);

  const handleRowSize = (page) => {
    console.log(page);
  };

  const handleSubmit = useCallback(async () => {
    const errors = checkFormValidation();
    if (Object.keys(errors).length > 0) {
      setErrorData(errors);
      return true;
    }
    submitToServer();
  }, [checkFormValidation, setErrorData, form]);

  const handlePayslipGenerate = useCallback(async () => {
    const errors = checkFormValidation();
    if (Object.keys(errors).length > 0) {
      setErrorData(errors);
      return true;
    }
    fetchPaySLip();
  }, [checkFormValidation, setErrorData, form]);

  useEffect(() => {
    handleSubmit();
  }, [form]);

  const handlePageChange = useCallback(
    (type) => {
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
        _processData();
      }
    },
    [_processData, setCurrentPage, data, totalShow]
  );

  return {
    handlePageChange,
    handleSortOrderChange,
    handleRowSize,
    totalShow,
    currentData,
    data,
    totalShow,
    form,
    generatePaySlip,
    isCalling,
    currentData,
    handleSubmit,
    currentPage,
    changeTextData,
    removeError,
    handlePayslipGenerate,
    lastPayslipGenrated,
    isGenerated,
    handleDownload,
    isDownload
  };
};

export default useSalaryReportListHook;
